import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';
import { TileResponse } from '../Store/tileSelectionSlice';

// Define the base API
export const tileSelectionApi = createApi({
    reducerPath: 'tileSelectionApi',
    baseQuery: baseQuery(),
    tagTypes: ['TileSelections'], 
    endpoints: (builder) => ({
        getTiles: builder.query<TileResponse[], {imageId: string, resultId: string}>({
            query: (body) => ({
                url: `/tile-registry/${body.imageId}/${body.resultId}`,
                method: "GET",
            }),
            providesTags: ['TileSelections'],
        }),
        submitTiles: builder.mutation({
            query: (body) => ({
                url: `/tile-registry/submit-labeling`,
                method: 'POST',
                body: body,
            }),
            // refreshes the "Previously Selected Tiles" list
            invalidatesTags: ['TileSelections'],
        }),
    }),
    // refetchOnMountOrArgChange: true // uncomment this line to disable cache invalidation
});

// Export the auto-generated hooks for use in your components
export const {
    useSubmitTilesMutation,
    useGetTilesQuery,
    // ... other exported queries or mutations
} = tileSelectionApi;

export default tileSelectionApi;
